import { useLoaderData, useLocation } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { ShoppingBasketCoCoScope } from '../../../../../common/enums.js';
import { employeeOmaElisaMsg, shopMsg, t } from '../../../../../common/i18n/index.js';
import { getLocalizedString } from '../../../../../common/utils/productOfferingsUtils.js';
import { DeviceDetailsCoCo } from '../../../../../components/DeviceDetailsCoCo/DeviceDetailsCoCo.js';
import { addToShoppingBasketCoCo } from '../../../../../components/ShoppingBasket/shoppingBasketFunctionsCoCo.js';
import type { PublicDeviceOfferLoaderData } from '../../../../../common/loaders.js';
import type { EmployeeProductListResponse } from '../../../../../generated/api/employeeProductListResponse.js';

export const EoeStoreProductCoCo = () => {
  const { offer } = useLoaderData() as PublicDeviceOfferLoaderData;
  const { state } = useLocation();
  const employeeProductList = state?.employeeProductList as EmployeeProductListResponse | undefined;

  return (
    <DeviceDetailsCoCo
      onAddToBasket={item =>
        addToShoppingBasketCoCo(
          { ...item, employeeProductList },
          1,
          undefined,
          undefined,
          ShoppingBasketCoCoScope.EMPLOYEE
        )
      }
      breadCrumbPaths={[
        { name: t.H6JV(employeeOmaElisaMsg), path: paths.EMPLOYEE_HOME },
        { name: t.BZGP(shopMsg), path: paths.EMPLOYEE_DEVICE_STORE },
        ...(employeeProductList
          ? [
              {
                name: employeeProductList.name ?? '',
                path: paths.EMPLOYEE_DEVICE_STORE_PHONES,
                state: { employeeProductList },
              },
            ]
          : []),
        { name: getLocalizedString(offer.name) },
      ]}
    />
  );
};
